"use client";

import { useMutation } from "@tanstack/react-query";
import { Effect } from "effect";
import { RpcClient } from "@effect/rpc";
import { featureAnnouncementsUserEq, FeatureAnnouncementsUserRpc } from "@/lib/effect-query";
interface UploadScreenshotsInput {
  readonly files: File[];
  readonly feedbackId: string;
}
export function useUploadFeedbackScreenshots() {
  const mutation = useMutation(featureAnnouncementsUserEq.mutationOptions({
    mutationKey: ["feature-announcements", "upload-screenshots"],
    mutationFn: ({
      files,
      feedbackId
    }: UploadScreenshotsInput) => Effect.gen(function* () {
      const client = yield* RpcClient.make(FeatureAnnouncementsUserRpc);
      for (const file of files) {
        const {
          screenshotId,
          uploadUrl
        } = yield* client.prepareScreenshotUpload({
          feedbackId,
          fileName: file.name,
          fileSize: file.size,
          contentType: file.type
        });
        yield* Effect.tryPromise({
          try: () => fetch(uploadUrl, {
            method: "PUT",
            body: file,
            headers: {
              "Content-Type": file.type
            }
          }),
          catch: error => new Error(`Failed to upload ${file.name}: ${error}`)
        });
        yield* client.completeScreenshotUpload({
          screenshotId,
          feedbackId,
          fileName: file.name,
          fileSize: file.size,
          contentType: file.type
        });
      }
    }).pipe(Effect.scoped)
  }));
  return {
    uploadScreenshots: mutation.mutateAsync,
    isUploading: mutation.isPending
  };
}